import { defineMessages } from "react-intl";

const baseId = "t.components.modals.confirmModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "Attention",
  },
  content: {
    id: baseId + "content",
    defaultMessage: "Are you sure you want to proceed?",
  },
  deleteBrContent: {
    id: baseId + "deleteBrContent",
    defaultMessage:
      "Removing the business role will result in the removal of profiles form all associated users.",
  },
  deleteBrAttachmentMessage: {
    id: baseId + "deleteBrAttachmentMessage",
    defaultMessage:
      "Attachments",
  },
  confirm: {
    id: baseId + "confirm",
    defaultMessage: "Confirm",
  },
  cancel: {
    id: baseId + "cancel",
    defaultMessage: "Cancel",
  },
});
